import { createStyles, LinearProgress, Theme, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { withSnackbar, WithSnackbarProps } from "notistack";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ApplicationState } from "../..";
import { endpoints } from "../../api/rtk/ExamSessionApi";
import { NewEntityId } from "../../data/constants";
import { ExamSessionViewModel } from "../../model/ExamSessionViewModel";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import ExamSessionGrid, { ExamSessionAddType } from "./ExamSessionGrid";
import ImportPevDialog from "./ImportPevDialog";

const styles = ({ spacing }: Theme) =>
  createStyles({
    button: { margin: spacing(1) },
    icon: { marginRight: spacing(1) },
  });

const mapStateToProps = (state: ApplicationState) => {
  return {
    examSessionsState: endpoints.getExamSessions.select()(state),
  };
};
const mapDispatchToProps = {
  getExamSessions: endpoints.getExamSessions.initiate,
};
const connector = connect(mapStateToProps, mapDispatchToProps);

type ExamSessionListProps = ConnectedProps<typeof connector> & RouteComponentProps & WithSnackbarProps;

type ExamSessionListState = {
  examSessions: ExamSessionViewModel[];
  isImportPevDialogOpen: boolean;
};

class ExamSessionList extends Component<ExamSessionListProps, ExamSessionListState> {
  constructor(props: ExamSessionListProps) {
    super(props);
    this.state = {
      examSessions: [],
      isImportPevDialogOpen: false,
    };
  }

  public componentDidMount() {
    this.props.getExamSessions();
  }

  public render() {
    return (
      <>
        <Typography variant="h5">
          <TranslatedMessage id="examSession.header" />
        </Typography>
        {this.renderExamSessions()}
      </>
    );
  }

  private renderExamSessions(): JSX.Element {
    const { isLoading, data: examSessions } = this.props.examSessionsState;

    if (isLoading) {
      return <LinearProgress variant="query" />;
    }

    if (examSessions === undefined) {
      return <></>;
    }

    const handleAddExamSession = (type: ExamSessionAddType) => {
      switch (type) {
        case "normal":
           this.navigateToExamSession(NewEntityId);
          break;
        case "life":
           this.navigateToExamSession(NewEntityId, true);
          break;
        case "builder":
          navigateTo(routesPaths.examSessionBuilder(), this.props.history);
          break;
      }
    };

    return (
      <>
        <ExamSessionGrid
          examSessions={examSessions}
          onExamSessionClick={this.navigateToExamSession}
          onAddClick={handleAddExamSession}
          onImportPevButtonClick={this.handleImportPevButtonClick}
        />
        <ImportPevDialog
          isOpen={this.state.isImportPevDialogOpen}
          onClose={this.handleImportPevDialogClose}
          onFileUploaded={this.handleImportPevSuccess}
        />
      </>
    );
  }

  private navigateToExamSession = (id: string, isLife?: boolean) => {
    if (isLife) {
      navigateTo(routesPaths.examSession(id, "true"), this.props.history);
    } else {
      navigateTo(routesPaths.examSession(id), this.props.history);
    }
  };

  private handleImportPevButtonClick = () =>
    this.setState((prevState) => {
      return {
        ...prevState,
        isImportPevDialogOpen: true,
      };
    });

  private handleImportPevSuccess = () => {
    this.props.enqueueSnackbar(<TranslatedMessage id="import.pev.success" />);
    this.handleImportPevDialogClose();
  };

  private handleImportPevDialogClose = () =>
    this.setState((prevState) => {
      return {
        ...prevState,
        isImportPevDialogOpen: false,
      };
    });
}

export default withStyles(styles)(connector(withSnackbar(ExamSessionList)));
